// Store reference to error dialog context getter
let getErrorDialog: (() => { showError: (message: string, details?: string) => void }) | null = null;
const SUCCESS_TOAST_EVENT = 'rh-tools:success-toast';

export function setErrorDialogGetter(getter: (() => { showError: (message: string, details?: string) => void }) | null) {
  getErrorDialog = getter;
}

export function notifyError(message: string, details?: string): void {
  try {
    // Try to use error dialog context if available
    if (getErrorDialog) {
      const { showError } = getErrorDialog();
      showError(message, details);
      return;
    }
  } catch (e) {
    // Fall through to console fallback if context not available
  }
  
  // Fallback to console if context is not available
  try {
    console.error(message);
    if (details) {
      console.error('Details:', details);
    }
  } catch {}
}

export interface SuccessNotificationAction {
  label: string;
  callback: () => void | Promise<void>;
}

export function notifySuccess(
  message: string,
  details?: string,
  action?: SuccessNotificationAction,
): void {
  try {
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(SUCCESS_TOAST_EVENT, { detail: { message, details, action } }));
      return;
    }
  } catch {}
}
